/* eslint-disable jira/filename-case */
import { loadQuery, type PreloadedQuery } from 'react-relay';
import type { ConcreteRequest, OperationType } from 'relay-runtime';
import getRelayEnvironment from '@jira/platform__graphql-relay-environment/src/index.tsx';
import { QueryPromisesMap } from '@atlassian/relay-query-promises';
import type { UserPrefsForIssueTableQuery } from '../../types.tsx';
import { transformToVariables } from './transform-to-variables.tsx';

export async function loadQueryWithUserPrefs<T extends OperationType>(
	{ filterId, columnNames, num, sortField, sortDirection }: UserPrefsForIssueTableQuery,
	query: ConcreteRequest,
	cloudId: string,
	activationId: string,
	fetchPolicy: 'store-only' | 'store-and-network' | 'store-or-network' = 'store-or-network',
	jql?: string,
): Promise<PreloadedQuery<T, {}>> {
	const { variables } = await transformToVariables({
		userPrefs: { filterId, columnNames, num, sortField, sortDirection },
		cloudId,
		activationId,
		jql,
	});

	const queryReference = loadQuery<T>(getRelayEnvironment(), query, variables, {
		fetchPolicy,
	});

	if (__SERVER__ && queryReference.id != null) {
		await QueryPromisesMap.get(queryReference.id);
	}

	return queryReference;
}
